<template>
  <a class="scroll-to-top"
      :class="{ 'scroll-to-top--active': isActive }"
      @click="onClick">
    <slot></slot>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ScrollToTop',
  props: {
    ShowIn: {
      default: 500,
      type: Number
    }
  },
  data() {
    return {
      last: 0,
      isActive: false
    }
  },
  watch: {
    scrollY(value) {
      this.isActive = value >= this.ShowIn && value >= this.last
      this.last = value
    }
  },
  computed: {
    ...mapGetters(['scrollY'])
  },
  methods: {
    onClick() {
      this.isActive = false

      window.scrollTop = 0
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0// For Chrome, Firefox, IE and Opera
    }
  }
}
</script>
